import React, { useEffect } from 'react';

export function DevToolsToggle({ isOpen, onToggle }) {
  // Global ⌘K / Ctrl+K keyboard shortcut
  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.metaKey || e.ctrlKey) && (e.key === 'k' || e.key === 'K')) {
        e.preventDefault();
        onToggle();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onToggle]);

  return (
    <button
      onClick={onToggle}
      aria-label="Toggle Developer Tools"
      aria-expanded={isOpen}
      className={`fixed right-0 bottom-20 sm:bottom-14 sm:right-6 z-[990] flex flex-col sm:flex-row items-center gap-1.5 sm:gap-2 px-2 py-3 sm:px-3.5 sm:py-2 rounded-l-xl rounded-r-none border-r-0 sm:rounded-full sm:border text-xs font-bold transition-all duration-300 cursor-pointer shadow-xl backdrop-blur-md border origin-right sm:origin-center group
        ${isOpen
          ? 'bg-gold text-black border-gold shadow-[0_0_20px_rgba(255,187,0,0.35)] scale-105'
          : 'bg-black/80 text-white/80 border-white/15 hover:text-gold hover:border-gold/40 hover:bg-black/90 hover:shadow-[0_0_20px_rgba(255,187,0,0.2)] hover:scale-105'
        }`}
    >
      <svg
        className={`w-3.5 h-3.5 sm:w-4 sm:h-4 transition-transform duration-300 ${isOpen ? 'rotate-90 text-black' : 'text-gold group-hover:rotate-45'}`}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2.2}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
      <span className="[writing-mode:vertical-rl] rotate-180 text-[11px] tracking-wider sm:[writing-mode:horizontal-tb] sm:rotate-0 sm:text-xs sm:tracking-normal">
        DevTools
      </span>
      <kbd
        className={`hidden sm:inline-block px-1.5 py-0.5 text-[10px] font-mono rounded transition-colors
          ${isOpen
            ? 'bg-black/20 text-black border border-black/20'
            : 'bg-white/10 text-gray-300 border border-white/10 group-hover:border-gold/30 group-hover:text-gold'
          }`}
      >
        ⌘K
      </kbd>
    </button>
  );
}

export default DevToolsToggle;
